import { AdminService, AdminTransactionsListResponseDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TExportFilters = {
  search: string;
  from: string;
  to: string;
};

export const fetchAllTransactionsForExport = async (
  call: TCall,
  { search, from, to }: TExportFilters,
): Promise<AdminTransactionsListResponseDto> => {
  const baseExportParams = {
    pageNo: '1',
    orderBy: 'createdAt',
    orderType: 'desc',
    search,
    from,
    to,
  };
  const countResponse = await call(() =>
    AdminService.getTransactionsList({
      ...baseExportParams,
      pageSize: '1',
    }),
  );

  if (countResponse.count === 0) {
    return { count: 0, data: [] };
  }

  return call(() =>
    AdminService.getTransactionsList({
      ...baseExportParams,
      pageSize: countResponse.count.toString(),
    }),
  );
};
